import { DataModel } from "../../base/DataModel.js";
import { ListDataModel } from "../../base/ListDataModel.js";
import type {
  ContainerEnvVariableData,
  ContainerEnvVariableListData,
} from "./types.js";

export class ContainerEnvVariable extends DataModel<ContainerEnvVariableData> {
  public readonly key: string;
  public readonly value: string;

  public constructor(data: ContainerEnvVariableData) {
    super(data);
    this.key = data.key;
    this.value = data.value;
  }

  public toString(): string {
    return this.key || this.value
      ? `${this.key ? this.key : ""}=${this.value ? this.value : ""}`
      : "";
  }
}

export class ContainerEnvVariableList extends ListDataModel<ContainerEnvVariable> {
  public constructor(envs: ContainerEnvVariableListData) {
    const envArray = [];
    for (const [key, value] of Object.entries(envs)) {
      envArray.push(new ContainerEnvVariable({ key, value: value }));
    }
    super(envArray, envArray.length);
  }

  public toApiDataObject(): ContainerEnvVariableListData {
    return this.items.reduce((prev, curr) => {
      return Object.assign(prev, { [curr.key]: curr.value });
    }, {});
  }
}
